import React, { PropsWithChildren } from 'react';
import { Button, Center, Heading, Text } from '@chakra-ui/react';
import { useAuth } from 'oidc-react';
import { Loader } from '../Loader/Loader';

type ProtectedAreaProps = PropsWithChildren<{
	authError?: Error | null;
	onRetry?: () => void;
}>;

// Navy like the sign-in pages it follows, so coming back from them doesn't flash a light page
const SigningInLoader = () => (
	<Loader
		variant="brand"
		tone="navy"
		label="Loading Section 8 Pro"
		centerHeight="100dvh"
	/>
);

export const ProtectedArea: React.FC<ProtectedAreaProps> = ({
	authError,
	onRetry,
	children,
}) => {
	const { isLoading, userData } = useAuth();

	if (isLoading) {
		return <SigningInLoader />;
	}

	if (!userData && authError) {
		return (
			<Center
				minH="100dvh"
				px={6}
				flexDirection="column"
				textAlign="center">
				<Heading as="h1" size="lg">
					We could not sign you in
				</Heading>
				<Text mt={3} maxW="520px">
					Please try again. If the problem continues, contact support.
				</Text>
				<Button mt={6} onClick={onRetry}>
					Try again
				</Button>
			</Center>
		);
	}

	if (!userData) {
		return <SigningInLoader />;
	}

	return <>{children}</>;
};
